import { Col, Row } from 'antd';
import { useEffect } from 'react';
import CustomCard from '../../../components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import { platformNames } from '../constants/platform-names.contants';
import { ensureSecondCarousel } from '../handle/ensure-second-carousel.handle';
import { hasTwoHomeCarousels } from '../handle/has-two-home-carousels.handle';
import { useCarouselPharmacyStore } from '../store/useCarouselPharmacyStore';
import { Service } from './service';
import './style.scss';

export default function CarouselPage() {
	const [pharmacy, platform, setPharmacy, setPlatform, setData] = useCarouselPharmacyStore((state) => [
		state.pharmacy,
		state.platform,
		state.setPharmacy,
		state.setPlatform,
		state.setData,
	]);

	const user = JSON.parse(localStorage.getItem('userInfo'));

	useEffect(() => {
		if (user) {
			new Service()
				.getCarousel('carousel', user.pharmacy)
				.then(async (response) => {
					const list = await ensureSecondCarousel({
						list: response.data,
						pharmacy: user.pharmacy,
						rootPharmacy: user.pharmacy,
						platform: user.platform,
						createFn: (body) => new Service().createCarousel(body),
					});
					setData(list);
					setPharmacy(user.pharmacy);
					setPlatform(user.platform);
				})
				.catch((error) => {
					console.log('error', error);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="admin-carousels">
			<h1>Configuración de carrouseles</h1>

			{pharmacy && (
				<>
					<h2>Seleccionar página a editar</h2>
					<Row>
						{pharmacy !== platformNames.pharol && !platform?.includes(platformNames.ecc) ? (
							<Col md={12} xs={24}>
								<CustomLink className="card-link-carousel" to={`/carousel/detail`}>
									<CustomCard
										className="carousel-cards"
										title={
											<div className="card-header-container">
												<h3>Corner {pharmacy === 'fanich' ? 'Anich' : pharmacy.toUpperCase()}</h3>
												<div className="inner-container">
													<p>1 elemento configurable</p>
												</div>
											</div>
										}
									>
										<CustomImage
											preview={false}
											src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
											alt="img"
										/>
									</CustomCard>
								</CustomLink>
							</Col>
						) : (
							<Col md={12} xs={24}>
								<CustomLink className="card-link-carousel" to={`/carousel/detail`}>
									<CustomCard
										className="carousel-cards"
										title={
											<div className="card-header-container">
												<h3>Home</h3>
												<div className="inner-container">
													<p>{hasTwoHomeCarousels(pharmacy, platform) ? '2 elementos configurables' : '1 elemento configurable'}</p>
												</div>
											</div>
										}
									>
										<CustomImage
											src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
											preview={false}
											alt="img"
										/>
									</CustomCard>
								</CustomLink>
							</Col>
						)}
					</Row>
				</>
			)}
		</div>
	);
}

